import { combineReducers } from 'redux';

import reportActionTypes from '../report/actionTypes';

import actionTypes from './actionTypes';
import defaults from './defaults';
import valuesReducer from './values';

const isVisibleReducer = (state = defaults.isVisible, action) => {
    switch (action.type) {
        case actionTypes.SET_FILTER_VISIBILITY:
            return action.payload.isVisible;
        default:
            return state;
    }
};

const appliedFiltersReducer = (state = {}, action) => {
    switch (action.type) {
        case actionTypes.HYDRATE_APPLIED_FILTERS:
        case actionTypes.SET_APPLIED_FILTERS:
            return action.payload.appliedFilters;
        case reportActionTypes.SET_REPORT_AND_FILTERS:
            return action.filters;
        case actionTypes.RESET_APPLIED_FILTERS:
            return defaults.values;
        default:
            return state;
    }
};

const reducer = combineReducers({
    isVisible: isVisibleReducer,
    values: valuesReducer,
    applied: appliedFiltersReducer,
});

export default reducer;
